var React = require('react');

function French (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ED2939","d":"M44 0H4a4 4 0 00-4 4v24a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4z","key":0}),React.createElement("path",{"fill":"#002395","d":"M21 0H4a4 4 0 00-4 4v24a4 4 0 004 4h17a4 4 0 004-4V4a4 4 0 00-4-4z","key":1}),React.createElement("path",{"fill":"#fff","d":"M32 0H16v32h16V0z","key":2})]);
}

French.defaultProps = {"fill":"none","viewBox":"0 0 48 32"};

module.exports = French;

French.default = French;
